'use client'

import { cn } from '@/lib/utils/utils'
import Link from 'next/link'
import ReactMarkdown from 'react-markdown'
import { Glossary } from './jbda/glossary'
import GlossaryLink from './jbda/glossary-link'

interface MDOptions {
  strongWeight?: number,
  textAlign?: 'left' | 'right' | 'center' | 'justify',
  onClickLink?: (href: any) => void,
  target?: string,
  rel?: string,
  children?: any,
  className?: string,
  glossary?: Glossary,
  ulGap?: number
}

const DEFAULT_OPTIONS: MDOptions = {
  strongWeight: 700,
  textAlign: 'left',
  target: '_self',
  ulGap: 0
}

export default function MD(props: MDOptions) {

  props = { ...DEFAULT_OPTIONS, ...props }
  // const { theme } = useTheme()

  return (
    <ReactMarkdown className={cn(props.className)} components={{
      p: ({ node, ..._props }) => <p style={{ textAlign: props.textAlign }} {..._props} />,
      strong: ({ node, ..._props }) => <span style={{ fontWeight: props.strongWeight }} {..._props} />,
      em: ({ node, ..._props }) => <span className='text-primary dark:text-primaryBright' {..._props} />,
      ul: ({ node, ordered, ..._props }) => <ul style={{ listStyle: 'disc inside', margin: props.ulGap + 'px 0' }} {..._props} />,
      a: ({ node, href, ..._props }) => {
        if (href && href.indexOf('/glossary#') === 0) {
          return <GlossaryLink _key={href.substring('/glossary#'.length)} glossary={props.glossary || {}} {..._props} />
        }
        return <Link target={props.target} rel={props.rel} className='dark:primaryBright cursor-pointer text-primary hover:underline' onClick={() => { if (props.onClickLink) props.onClickLink(href) }} href={href as string} {..._props} />
      },
      hr: () => <hr style={{ width: '100%', height: '1px', backgroundColor: 'gray', opacity: '0.1', margin: '8px 0' }} />,
      h1: ({ node, ..._props }) => <h1 style={{ fontSize: '2rem' }} {..._props} />,
      h2: ({ node, ..._props }) => <h2 style={{ fontSize: '1.5rem' }} {..._props} />,
      h3: ({ node, ..._props }) => <h3 style={{ fontSize: '1.25rem' }} {..._props} />,
      code: ({ node, ..._props }) => <span style={{ background: '#fff58599' }} {..._props} />
    }}>
      {props.children}
    </ReactMarkdown>
  )

}
